__turbopack_context__.v({
  "globeContainer": "HeroGlobe-module__ckPvEW__globeContainer",
  "globeWrapper": "HeroGlobe-module__ckPvEW__globeWrapper",
  "headline": "HeroGlobe-module__ckPvEW__headline",
  "headlineReveal": "HeroGlobe-module__ckPvEW__headlineReveal",
  "headlineVisible": "HeroGlobe-module__ckPvEW__headlineVisible",
  "highlight": "HeroGlobe-module__ckPvEW__highlight",
  "line1": "HeroGlobe-module__ckPvEW__line1",
  "line2": "HeroGlobe-module__ckPvEW__line2",
  "line4": "HeroGlobe-module__ckPvEW__line4",
  "nightButton": "HeroGlobe-module__ckPvEW__nightButton",
  "nightButtonActive": "HeroGlobe-module__ckPvEW__nightButtonActive",
  "shifted": "HeroGlobe-module__ckPvEW__shifted",
  "skipButton": "HeroGlobe-module__ckPvEW__skipButton",
});
